import axios from 'axios';
export const apiBaseUrl = 'https://duboisorders.com:3000/admin/api/';
export const ImageUrl = 'https://duboisorders.com:3000'

// export const apiBaseUrl = 'https://dev.duboisorders.com:3001/admin/api/';
// export const ImageUrl = 'https://dev.duboisorders.com:3001';

const axiosInstance = axios.create({
    baseURL: apiBaseUrl,
    headers: {
        'Content-Type': 'application/json'
    }
});


const axiosInstanceFormData = axios.create({
    baseURL: apiBaseUrl,
    headers: {
        'Content-Type': 'multipart/form-data', // Required for FormData                                                                    
    }
});



// Add token to headers if available in localStorage
const addAuthToken = () => {
    const token = localStorage.getItem('token');
    if (token) {
        axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`;
        axiosInstanceFormData.defaults.headers['Authorization'] = `Bearer ${token}`;
    } else {
        console.warn('No token found in localStorage');
    }
};



// POST Request
export const post = async (url, data) => {
    addAuthToken(); // Ensure token is added
    try {
        const response = await axiosInstance.post(url, data);
        return response.data; // Return data from response
    } catch (error) {
        console.error('POST request failed:', error);
        throw error.response ? error.response.data : error; // Return error data
    }
};

export const postFormData = async (url, data) => {
    addAuthToken(); // Ensure token is added
    try {
        const response = await axiosInstanceFormData.post(url, data);
        return response.data; // Return data from response
    } catch (error) {
        console.error('POST request failed:', error);
        throw error.response ? error.response.data : error; // Return error data
    }
};

// GET Request
export const get = async (url, params = {}) => {

    addAuthToken(); // Ensure token is added
    try {
        const response = await axiosInstance.get(url, { params });
        return response.data; // Return data from response
    } catch (error) {
        console.error('GET request failed:', error);
        if (error?.response?.data?.message == "Invalid or expired token" || error?.response?.data?.message == "Invalid Token") {
            localStorage.removeItem('token');
        }
        throw error.response ? error.response.data : error; // Return error data
    }
};

// PUT Request (optional, if needed)
export const put = async (url, data) => {
    addAuthToken(); // Ensure token is added
    try {
        const response = await axiosInstance.put(url, data);
        return response.data; // Return data from response
    } catch (error) {
        console.error('PUT request failed:', error);
        throw error.response ? error.response.data : error;
    }
};

// DELETE Request (optional, if needed)
export const DELETE = async (url, data) => {
    addAuthToken(); // Ensure token is added 
    try {
        const response = await axiosInstance.delete(url);
        return response.data; // Return data from response
    } catch (error) {
        console.error('DELETE request failed:', error);
        throw error.response ? error.response.data : error; // Return error data
    }
};


export const downloadExcel = async (url, filename = "download-reports.csv", params = {}) => {
    addAuthToken(); // Ensure token is added

    try {
        const response = await axiosInstance.get(url, {
            params,
            responseType: 'blob', // Important for binary data
        });

        // Create a blob from the response - using text/csv MIME type
        const blob = new Blob([response.data], { type: 'text/csv' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;

        // Set the filename with .csv extension
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        // Clean up
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        console.error('CSV download failed:', error);
        if (
            error?.response?.data?.message === 'Invalid or expired token' ||
            error?.response?.data?.message === 'Invalid Token'
        ) {
            localStorage.removeItem('token');
        }
        throw error.response ? error.response.data : error;
    }
};